import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State } from './reducer';

export const selectState = createFeatureSelector<State>('revenuecat');

export const selectPackages = createSelector(
  selectState,
  (state) => state.packages
);

export const selectCustomerInfo = createSelector(
  selectState,
  (state) => state.customerInfo
);

export const selectLoginItem = createSelector(
  selectState,
  (state) => state.loginItem
);




export const selectLoading = createSelector(
  selectState,
  (state) => state.loading
);

export const selectError = createSelector(
  selectState,
  (state) => state.error
);

export const selectActiveEntitlements = createSelector(
  selectCustomerInfo,
  (customerInfo) => customerInfo?.entitlements?.active?.['Premium'] || {}
);

export const selectIsPro = createSelector(
  selectActiveEntitlements,
  (active) => Object.keys(active).length > 0
);
